// extracted by mini-css-extract-plugin
export default {"suggestionButton":"SuggestionCard-module__suggestionButton__r9oyNd9","icon":"SuggestionCard-module__icon__qfG7fI4"};